import React, { FC } from 'react';
import { ChevronSmallFilledIcon } from '@move-ui/icons-asset-catalog';
import { FLAG_ICON } from '../../config';
import styles from './LanguageSwitcher.css';
import { useTranslation } from '../../utils/translations';

type Props = {
  locale: string;
  onLocaleChange: (locale: string) => void;
};

type LocaleOption = { value: string; label: string };

const LanguageSwitcher: FC<Props> = ({ locale, onLocaleChange }) => {
  const { translate } = useTranslation();

  const localeOptions: LocaleOption[] = [
    {
      value: 'en-CA',
      label: translate('language_switch_en_ca')
    },
    {
      value: 'fr-CA',
      label: translate('language_switch_fr_ca')
    }
  ];

  return (
    <div className={styles.component}>
      <img alt={translate('language_switch_flag_icon_alt')} src={FLAG_ICON} />

      <select
        className={styles.select}
        onChange={(e) => onLocaleChange(e.target.value)}
        value={locale}
        aria-label={translate('language_switch_title')}
        data-testid="LanguageSwitcherSelect"
      >
        <optgroup label={translate('language_switch_title')} />
        {localeOptions.map((localeOption) => (
          <option key={localeOption.value} value={localeOption.value}>
            {localeOption.label}
          </option>
        ))}
      </select>

      <ChevronSmallFilledIcon className={styles.arrow} />
    </div>
  );
};

export default LanguageSwitcher;
